<script setup lang="ts">
import { ProtocolDto } from '@/api/generator';
import { api } from '@/api';
import { onMounted, ref } from 'vue';
import VeeAutocomplete from '../forms/Autocomplete/VeeAutocomplete.vue';
import { SelectItemTypeObject } from '../forms/types';
import IdentifierLabel from '../IdentifierLabel/IdentifierLabel.vue';

defineProps<{
  name: string;
}>();

type ProtocolOption = SelectItemTypeObject<ProtocolDto>;

const items = ref<ProtocolOption[]>();

async function getProtocols() {
  const { result } = await api.protocolsApi.getProtocolList();

  items.value = (result?.value || undefined)?.map<ProtocolOption>((p) => ({
    title: `${p.name} (${p.iuid})`,
    value: p,
  }));
}

function valueComparator(option: ProtocolDto, selected: ProtocolDto) {
  return option.id === selected.id;
}

onMounted(getProtocols);
</script>

<template>
  <VeeAutocomplete
    :items="items"
    solo
    chips
    clearable
    multiple
    :label="$t('Protocol_other')"
    :name="name"
    :valueComparator="valueComparator"
  >
    <template #itemTitle="{ value: { name: label, iuid } }">
      <IdentifierLabel :label="label" :identifier="iuid" />
    </template>
  </VeeAutocomplete>
</template>
